import React from "react";
const RenderChildrenWrapper = ({ wrapper, children, }) => {
    return wrapper ? wrapper(children) : React.createElement(React.Fragment, null, children);
};
export default RenderChildrenWrapper;
//# sourceMappingURL=RenderChildrenWrapper.js.map